'use client';

import { ISalePageCommentResponse } from '@/api/types';
import { useUpdateSalePageComment } from '@/entities/salePage';
import { useModal } from '@/hooks/useModal';
import { SalePageCommentInput } from './CommentInput';

interface SalePageCommentCommentUpdateInputProps {
  comment: ISalePageCommentResponse;
  salePageId: number;
  exitEditMode: VoidFunction;
}

export const SalePageCommentCommentUpdateInput = ({
  comment,
  salePageId,
  exitEditMode,
}: SalePageCommentCommentUpdateInputProps) => {
  const { mutate: updateSalePageComment } = useUpdateSalePageComment();
  const { confirm } = useModal();

  const handleEnter = (value: string) => {
    updateSalePageComment(
      {
        commentId: comment.id,
        salePageId,
        content: value,
      },
      {
        onSuccess: () => {
          exitEditMode();
        },
        onError: error => {
          confirm({
            title: '안내',
            description:
              error.response?.data.error.message ||
              '댓글을 수정할 수 없습니다.',
          });
        },
      }
    );
  };

  const handleBlur = () => {
    exitEditMode();
  };

  return (
    <SalePageCommentInput
      onBlur={handleBlur}
      onEnterKeyDown={handleEnter}
      initialValue={comment.content}
      autoFocus
    />
  );
};
